"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberBase = exports.anonymizedPhone = exports.isE164Number = void 0;
var E164_REGEX = /^\+[1-9][0-9]{1,14}$/;
function isE164Number(phoneNumber) {
    return E164_REGEX.test(phoneNumber);
}
exports.isE164Number = isE164Number;
function anonymizedPhone(phoneNumber) {
    return phoneNumber.slice(0, -4) + 'XXXX';
}
exports.anonymizedPhone = anonymizedPhone;
exports.PhoneNumberBase = {
    isE164Number: isE164Number,
};
//# sourceMappingURL=phoneNumbers.js.map